<template>
  <b-card class="shadow rounded position-relative">
    <b-button
      v-b-tooltip.hover="'Open user guide'"
      class="help-btn"
      variant="outline-secondary"
      size="sm"
      aria-label="Open user guide"
      @click="showHelp = true"
      >?</b-button
    >
    <router-link to="/">
      <img
        title="HEIDI Precision Dosing Calculator"
        alt="Logo"
        src="@/assets/img/dosing_dark.png"
        :width="size"
        :height="size"
    /></router-link>
    <b-card-body>
      <b-card-text>Precision dosing plans based on patient data</b-card-text>
    </b-card-body>
    <HelpPanel v-model="showHelp" />
  </b-card>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue';
import HelpPanel from '@/components/HelpPanel.vue';

defineOptions({ name: 'TitleComponent' });

const showHelp = ref(false);
const size = computed(() => (window.innerWidth > 500 && window.innerHeight > 500 ? 200 : 100));
</script>

<style scoped>
img {
  border-radius: 100px;
}

h1 {
  font-size: 1.6rem;
}

.text-left {
  text-align: left;
}

.help-btn {
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
  width: 2rem;
  height: 2rem;
  padding: 0;
  font-weight: 600;
  border-radius: 50%;
  line-height: 1;
}
</style>
